import { Component, Input, signal } from '@angular/core';
import { InvestisseurFicheObjectif, ObjectifReferentielFiche } from '@lib/models/generated/graphql';
import { Subject, takeUntil } from 'rxjs';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';
import { ObjectifsValidatorKey } from 'src/fieldFormControl/validators/objectifValidator';

@Component({
  selector: 'app-objectif-checkbox',
  templateUrl: './objectif-checkbox.component.html',
  styleUrls: ['./objectif-checkbox.component.scss'],
})
export class ObjectifCheckboxComponent {
  @Input({ required: true }) objectifReferentiel: ObjectifReferentielFiche;
  showGroupError = signal(false);
  showMandatoryError = signal(false);
  showIncompatibleError = signal(false);

  ficheObjectif?: InvestisseurFicheObjectif;
  control: FieldFormControl<boolean, InvestisseurFicheObjectif>;
  isDeactive: boolean = true;
  isInitialized: boolean = false;
  isInRequiredGroup: boolean = false;
  isForbiden: boolean = false;
  private ngUnsubscribe = new Subject<void>();
  constructor(protected ficheConseilService: FicheConseilService, protected formConfigService: FormConfigService) {}
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  ngOnInit() {
    this.ficheConseilService.currentFicheConseilSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe(currentFiche => {
      // get objectif from fiche

      this.ficheObjectif = currentFiche?.objectifs?.find(
        objectif => objectif?.objectifCode === this.objectifReferentiel?.code
      );
      if (!this.isInitialized) {
        this.control = new FieldFormControl<boolean, InvestisseurFicheObjectif>({
          formConfigService: this.formConfigService,
          ficheConseilService: this.ficheConseilService,
          dataKey: 'objectifs',
          defaultValue: this.ficheObjectif?.isSelected ?? false,
          ficheDataToFieldDataWrapper: (data: any) => data?.isSelected,
          fieldDataToFicheDataWrapper: (fieldData: boolean) => {
            if (this.ficheObjectif) {
              return {
                ...this.ficheObjectif,
                isSelected: fieldData,
              };
            }
            return this.ficheObjectif ?? null;
          },
          arrayItemSelector: (data: any) => {
            return data && this.objectifReferentiel && data?.objectifCode === this.objectifReferentiel?.code;
          },
          options: { nonNullable: true },
          params: {
            objectifCode: this.objectifReferentiel?.code,
          },
        });
        this.isInitialized = true;
      }
      if (!this.ficheObjectif) {
        if (this.control.value) {
          this.control.setValue(false);
        }
        this.control.disable();
      } else {
        this.control.enable();
      }
    });

    this.isInRequiredGroup = (
      this.formConfigService.currentFormConfigSubject.value?.fieldConfigs
        ?.find(f => f.fieldKey === 'objectifs')
        ?.validators.find(v => v.validatorKey === ObjectifsValidatorKey.auMoinsUn)
        ?.parameters.find(p => p.key === 'codes')
        ?.value?.split(',') ?? []
    ).includes(this.objectifReferentiel?.code);
  }


  setGroupError(isGroupError: boolean) {
    this.showGroupError.set(isGroupError);
  }


  get errortexts() {
    let base = this.control?.getErrorTextfieldErrors() ?? [];
    return [
      ...base,
      {
        code: ObjectifsValidatorKey.obligatoire + '_missing',
        message:
          'Cet objectif est obligatoire avec l’enveloppe de cette fiche conseil. Il faut donc que cet objectif soit présent dans le recueil de vos investisseurs.',
      },
    ];
  }

  get customErrorMessage() {
    return 'Cet objectif est obligatoire avec l’enveloppe de cette fiche conseil. Il faut donc que cet objectif soit trouvé dans le recueil de vos investisseurs.';
  }

  get customIncomatibleErrorMessage() {
    return "Cet objectif n'est pas compatible avec l'enveloppe de cette fiche conseil.";
  }
  get shouldDisplayCustomErrorMessage() {
    return this.isInRequiredGroup && this.control.disabled;
  }

  get customAuMoinsUnErrorMessage() {
    return 'L’un des objectifs doit être sélectionné.';
  }

  get customMandatoryErrorMessage() {
    return 'Cet objectif est obligatoire avec l’enveloppe de cette fiche conseil.';
  }

  public markAsTouched(): void {
    this.control.markAsTouched();
  }

  public isValid(): boolean {
    return this.control.errors === null && this.shouldDisplayCustomErrorMessage === false;
  }
}
